<template>
  <div class="wrapper">
    <header>开票申请</header>
    <section>
      <div class="company">
        <!-- <p class="iconfont">&#xe614;</p> -->
        <p class="companyName">{{settlementInfo.sellerName || ''}}</p>
      </div>
      <div class="money">
        <p class="title">开票金额</p>
        <p class="count-wrp"><span class="tag">¥</span> <span class="count">{{settlementInfo.amountWithTax || 0}}</span></p>
      </div>
      <div class="form">
        <FormList
          v-if="formData.invoiceDimension !== '1' && this.settlementInfo.invoiceType !== 4 && ![7,8].includes(this.settlementInfo.invoiceType)"
          :list="formList"
          :data="formData"
          :onChange="onInputChange"
          :onBlur="onBlur"
          :onFocus="onFocus"
          :key="formList[0].options.length"
        />
        <FormList
          v-if="formData.invoiceDimension !== '1' && [7,8].includes(this.settlementInfo.invoiceType)"
          :list="fullPowerformList"
          :data="formData"
          :onChange="onInputChange"
          :onBlur="onBlur"
          :onFocus="onFocus"
          :key="fullPowerformList[0].options.length"
        >
          <template slot="purchaserShowFlag">
            <van-checkbox :value="!!formData.purchaserShowFlag" icon-size="14px" shape="square" @click="changepurchaserShowFlag">是否展示</van-checkbox>
          </template>
        </FormList>
        <FormList
          v-if="formData.invoiceDimension === '1' && this.settlementInfo.invoiceType !== 4"
          :list="formPersonList"
          :data="formData"
          :onChange="onInputChange"
          :onBlur="onBlur"
          :onFocus="onFocus"
        />

        <FormList
          v-if="formData.invoiceDimension !== '1' && this.settlementInfo.invoiceType === 4"
          :list="formListSpecial"
          :data="formData"
          :onChange="onInputChange"
          :onBlur="onBlur"
          :onFocus="onFocus"
          :key="formList[0].options.length"
        />
        <FormList
          v-if="formData.invoiceDimension === '1' && this.settlementInfo.invoiceType === 4"
          :list="formPersonListSpecial"
          :data="formData"
          :onChange="onInputChange"
          :onBlur="onBlur"
          :onFocus="onFocus"
        />

        <div class="rollup" v-if="showTakerList && formalinvoiceList.length > 0">
          <div
            @click="onSelectCompany(item)"
            class="rollup-item"
            v-for="(item, index) in formalinvoiceList"
            :key="index"
          >
            <div class="rollup-company">
              <div>{{ item.name }}</div>
              <div v-if="item && item.managementBuyerFlag === 1">已添加</div>
            </div>
          </div>
          <div
            @click="showTakerList = false"
            class="rollup-item"
          >
            <div class="rollup-company">
              <div>关闭</div>
            </div>
          </div>
        </div>
      </div>
      <div class="detail-wrp">
        <div class="detail-list-wrp" v-if="goodsList.length > 0 ? true : false">
          <div class="detail-title">
            <span class="name">名称</span>
            <span class="count">数量</span>
            <span class="sum">合计</span>
          </div>
          <div class="detail-item" v-for="(item, index) in goodsList" :key="index">
            <span class="name">{{item.goodsName}}</span>
            <span class="count">{{item.quantity}}</span>
            <span class="sum">{{item.amountWithTax}}</span>
          </div>
        </div>
      </div>
    </section>
    <footer>
      <van-button @click="submit" class="button">开具发票</van-button>
    </footer>
  </div>
</template>
<script>
import { Button, Notify, Toast, Checkbox } from 'vant'
import FormList from '@components/FormList'
import { businessRequest } from '@services'
import {
  ORDER_INVOICE_TYPE
} from '@assets/config'
import { debounce, aesDoDecrypt, getQuery, isEmail, isSpecialTicket, isAllElectric, CheckBusinessMainInfo, isUniversalTicket, autoMontageLookUp, removeSpace } from '@/utils/basicUtil'
export default {
  components: {
    [Notify.name]: Notify,
    [Button.name]: Button,
    [Checkbox.name]: Checkbox,
    [Toast.name]: Toast,
    FormList
  },
  props: {},
  data () {
    return {
      formList: [
        {
          type: 'radio',
          field: 'invoiceDimension',
          label: '开票类型',
          options: ORDER_INVOICE_TYPE
        },
        {
          type: 'text',
          field: 'purchaserName',
          placeholder: '请输入开票抬头',
          label: '开票抬头'
        },
        {
          type: 'text',
          field: 'purchaserTaxNo',
          placeholder: '请输入开票税号',
          label: '开票税号'
        },
        {
          type: 'text',
          field: 'purchaserAddress',
          placeholder: '请输入地址、电话',
          label: '地址、电话'
        },
        {
          type: 'text',
          field: 'purchaserBankName',
          placeholder: '请输入开户行、账号',
          label: '开户行、账号'
        },
        {
          type: 'text',
          field: 'purchaserEmail',
          placeholder: '请输入邮箱',
          label: '邮箱'
        },
        {
          type: 'text',
          field: 'purchaserPhone',
          placeholder: '请输入手机号',
          label: '手机号'
        },
        {
          type: 'text',
          field: 'remark',
          placeholder: '请输入备注',
          label: '备注(选填)'
        }
      ],
      fullPowerformList: [
        {
          type: 'radio',
          field: 'invoiceDimension',
          label: '开票类型',
          options: ORDER_INVOICE_TYPE
        },
        {
          type: 'text',
          field: 'purchaserName',
          placeholder: '请输入开票抬头',
          label: '开票抬头'
        },
        {
          type: 'text',
          field: 'purchaserTaxNo',
          placeholder: '请输入开票税号',
          label: '开票税号'
        },
        {
          type: 'text',
          field: 'purchaserAddress',
          placeholder: '填写购买方地址',
          label: '地址'
        },
        {
          type: 'text',
          field: 'purchaserTel',
          placeholder: '填写电话',
          label: '电话'
        },
        {
          type: 'text',
          field: 'purchaserBankName',
          placeholder: '填写开户行',
          label: '开户行'
        },
        {
          type: 'text',
          field: 'purchaserBankAccount',
          placeholder: '填写银行账号',
          label: '账号',
          slot: 'purchaserShowFlag'
        },
        {
          type: 'text',
          field: 'purchaserEmail',
          placeholder: '请输入邮箱',
          label: '邮箱'
        },
        {
          type: 'text',
          field: 'purchaserPhone',
          placeholder: '请输入手机号',
          label: '手机号'
        },
        {
          type: 'text',
          field: 'remark',
          placeholder: '请输入备注',
          label: '备注(选填)',
          maxlength: 200
        }
      ],
      formPersonList: [
        {
          type: 'radio',
          field: 'invoiceDimension',
          label: '开票类型',
          options: ORDER_INVOICE_TYPE
        },
        {
          type: 'text',
          field: 'purchaserName',
          placeholder: '请输入开票抬头',
          label: '开票抬头'
        },
        {
          type: 'text',
          field: 'purchaserEmail',
          placeholder: '请输入邮箱',
          label: '邮箱'
        },
        {
          type: 'text',
          field: 'purchaserPhone',
          placeholder: '请输入手机号',
          label: '手机号'
        },
        {
          type: 'text',
          field: 'remark',
          placeholder: '请输入备注',
          label: '备注(选填)'
        }
      ],
      formListSpecial: [
        {
          type: 'radio',
          field: 'invoiceDimension',
          label: '开票类型',
          options: [
            {
              title: '企业',
              value: '0'
            }
          ]
        },
        {
          type: 'text',
          field: 'purchaserName',
          placeholder: '请输入开票抬头',
          label: '开票抬头'
        },
        {
          type: 'text',
          field: 'purchaserTaxNo',
          placeholder: '请输入开票税号',
          label: '开票税号'
        },
        {
          type: 'text',
          field: 'purchaserAddress',
          placeholder: '请输入地址、电话',
          label: '地址、电话'
        },
        {
          type: 'text',
          field: 'purchaserBankName',
          placeholder: '请输入开户行、账号',
          label: '开户行、账号'
        },
        {
          type: 'text',
          field: 'purchaserPhone',
          placeholder: '请输入手机号',
          label: '手机号'
        },
        {
          type: 'text',
          field: 'purchaserEmail',
          placeholder: '请输入邮箱',
          label: '邮箱'
        },
        {
          type: 'text',
          field: 'remark',
          placeholder: '请输入备注',
          label: '备注(选填)'
        }
      ],
      formPersonListSpecial: [
        {
          type: 'radio',
          field: 'invoiceDimension',
          label: '开票类型',
          options: [
            {
              title: '企业',
              value: '0'
            }
          ]
        },
        {
          type: 'text',
          field: 'purchaserName',
          placeholder: '请输入开票抬头',
          label: '开票抬头'
        },
        {
          type: 'text',
          field: 'purchaserEmail',
          placeholder: '请输入邮箱',
          label: '邮箱'
        },
        {
          type: 'text',
          field: 'remark',
          placeholder: '请输入备注',
          label: '备注(选填)'
        }
      ],
      formData: {
        invoiceDimension: '0',
        purchaserName: '',
        purchaserTaxNo: '',
        purchaserAddress: '',
        purchaserTel: '',
        purchaserBankName: '',
        purchaserBankAccount: '',
        purchaserEmail: '',
        purchaserPhone: '',
        id: '',
        remark: ''
      },
      formalinvoiceList: [],
      goodsList: [],
      showTakerList: false,
      settlementInfo: {},
      newSettlementId: ''
    }
  },
  computed: {},
  watch: {},
  created () {},
  mounted () {
    this.getOrderInfo()
  },
  activated () {},
  updated () {},
  methods: {
    changepurchaserShowFlag () {
      this.changeApply({
        purchaserShowFlag: this.formData.purchaserShowFlag ? 0 : 1
      })
    },
    async getOrderInfo () {
      let { key } = getQuery()
      if (!key) {
      // 如果key 不存在跳转到失效页面
        this.$router.push(`/order/overdue`)
        return
      }
      let info = aesDoDecrypt(key)
      console.log(info)
      const params = {
        settlementId: info.settlementId,
        id: info.id
      }
      const data = await businessRequest.qrcode.getOrderInfo(params)
      if (data.result && data.result.settlementId) {
        this.newSettlementId = data.result.settlementId
      } else {
        this.newSettlementId = params.settlementId
      }
      if (data.success) {
        // 先去判断是否开具了发票
        if (data.result.issueInvoiceState === 1) {
          // 0 未开具 1 已开具
          this.$router.push(`/order/apply-success?invoiceId=${this.newSettlementId}`)
          return
        } else {
          // valid 0 过期
          if (data.result.valid === 0) {
            this.$router.push(`/order/overdue`)
            return
          }
        }
        let lostTime = data.result.lostTime
        // 不存在过期日期，跳转失效页面
        if (!lostTime) {
          this.$router.push(`/order/overdue`)
          return
        }
        // 转换一下日期，因为可能部分ios手机带-的会报错NaN转换失败
        lostTime = lostTime.replace(/-/g, '/')
        // 当前日期 > 过期截止日期，跳转到失效页面
        if (new Date().getTime() > new Date(lostTime).getTime()) {
          this.$router.push(`/order/overdue`)
          return
        }
        // 如果当前二维码上的updateTime ！== data.result.updateTime 说明改过当前单据，即单据失效
        if (info.updateTime !== data.result.updateTime) {
          this.$router.push(`/order/overdue`)
          return
        }
        this.goodsList = data.result.details || []
        this.formData.id = this.newSettlementId
        this.formData.agentSettlementId = info.id
        this.settlementInfo = data.result
      } else {
        Notify({ type: 'danger', message: data && data.result ? data.result.message : '操作失败' })
        this.$router.push(`/order/overdue`)
      }
    },
    onInputChange ({ e, field }) {
      if (field === 'purchaserName') {
        if (this.formData.invoiceDimension !== '1') {
          this.showTakerList = true
          this.onSearch(e)
        }
      }
      if (field === 'purchaserTaxNo') {
        e = e ? e.toUpperCase() : e
      }
      this.changeApply({
        [field]: removeSpace(e)
      })
    },
    changeApply (params) {
      this.formData = {
        ...this.formData,
        ...params
      }
    },
    onBlur ({ e, field }) {
      if (field === 'purchaserName') {
        this.testPurchaserName()
      } else if (field === 'purchaserTaxNo') {
        this.testPurchaserTaxNo()
      } else if (field === 'purchaserEmail') {
        this.testPurchaserEmail()
      }
    },
    onFocus ({ e, field }) {
      if (field === 'purchaserName') {

      }
    },
    sliceStr (text, len) {
      if (text && text.length > len) {
        return text.slice(0, len) + '...'
      } else {
        return text
      }
    },
    debounce: debounce((vm) => { vm.getCustomerListByName() }, 300),
    onSearch (value) {
      if (value.length >= 1) {
        this.debounce(this)
      }
    },
    async getCustomerListByName () {
      if (!this.formData.purchaserName) {
        return
      }
      const data = await businessRequest.qrcode.getSmartTitle({ companyName: this.formData.purchaserName })
      if (data.success) {
        if (data.result.length) {
          this.formalinvoiceList = data.result
        } else {
          this.formalinvoiceList = []
        }
      } else {
        Notify({ type: 'danger', message: data.message })
      }
    },
    onSelectCompany (item) {
      const { address, bankName, bankNo, name, taxNo, tel } = autoMontageLookUp(item, this.settlementInfo.invoiceType)
      this.changeApply({
        purchaserName: name,
        purchaserTaxNo: taxNo ? taxNo.toUpperCase() : taxNo,
        purchaserAddress: `${address || ''}`,
        purchaserBankName: `${bankName || ''}`,
        purchaserTel: tel || '',
        purchaserBankAccount: bankNo || ''
      })
      this.formalinvoiceList = []
    },
    async submit () {
      if (!this.testPurchaserName() || !this.testPurchaserTaxNo() || !this.testPurchaserEmail() || !this.testPurchaserBank() || !this.testPurchaserAddress()) {
        return
      }
      // 校验购销方主体信息
      try {
        const check = new CheckBusinessMainInfo({ invoiceType: this.settlementInfo.invoiceType })
        if (this.formData.invoiceDimension !== '1') {
          check.purchaserName({ value: this.formData.purchaserName })
          check.purchaserTaxNo({ value: this.formData.purchaserTaxNo })
          check.purchaserAddress({ value: this.formData.purchaserAddress })
          check.purchaserTel({ value: this.formData.purchaserTel, required: false })
          check.purchaserBankName({ value: this.formData.purchaserBankName })
          check.purchaserBankAccount({ value: this.formData.purchaserBankAccount, required: false })
        }
        check.remark({ value: this.formData.remark })
      } catch (error) {
        if (error.message) {
          Notify({ type: 'danger', message: error.message })
        }
        return
      }
      let params = {
        invoiceDimension: this.formData.invoiceDimension,
        purchaserName: this.formData.purchaserName,
        purchaserTaxNo: this.formData.purchaserTaxNo ? this.formData.purchaserTaxNo.replace(/\s+/g, '') : this.formData.purchaserTaxNo,
        purchaserAddress: this.formData.purchaserAddress,
        purchaserTel: this.formData.purchaserTel,
        purchaserBankName: this.formData.purchaserBankName,
        purchaserBankAccount: this.formData.purchaserBankAccount,
        purchaserEmail: this.formData.purchaserEmail,
        id: this.formData.id,
        agentSettlementId: this.formData.agentSettlementId,
        purchaserPhone: this.formData.purchaserPhone,
        remark: this.formData.remark,
        purchaserShowFlag: this.formData.purchaserShowFlag,
        invoiceType: this.settlementInfo.invoiceType,
        invoiceSource: 2
      }
      if (params.purchaserEmail === '' && params.purchaserPhone === '') {
        Notify({ type: 'danger', message: '请输入邮箱或手机号' })
        return false
      }
      Toast.loading({
        message: '请求中...',
        forbidClick: true,
        duration: 0
      })
      // invoiceDimension === '1' 就是自然人 自然人personLogo字段是1
      if (isUniversalTicket(params.invoiceType) && isAllElectric(params.invoiceType)) {
        params.personLogo = params.invoiceDimension === '1' ? 1 : 0
      }
      if (!isAllElectric(params.invoiceType)) {
        params.purchaserShowFlag = 0
      }
      const data = await businessRequest.qrcode.invoice(params)
      if (data.success) {
        Toast.clear({
          clearAll: true
        })
        this.$router.push(`/order/apply-success?invoiceId=${data.result}`)
      } else {
        Toast.clear({
          clearAll: true
        })
        Notify({ type: 'danger', message: data && data.result ? data.result.message : '操作失败' })
      }
    },
    testPurchaserName () {
      if (!this.formData.purchaserName) {
        Notify({ type: 'danger', message: '请填写开票抬头' })
        return false
      }
      return true
    },
    testPurchaserTaxNo () {
      if (['0', '2'].includes(this.formData.invoiceDimension)) {
        if (isSpecialTicket(this.settlementInfo.invoiceType)) {
          if (!this.formData.purchaserTaxNo.length) {
            Notify({ type: 'danger', message: '请填写开票税号' })
            return false
          }
          if (!/^[0-9A-Za-z]{9}$|^[0-9A-Za-z]{15}$|^[0-9A-Za-z]{17}$|^[0-9A-Za-z]{18}$|^[0-9A-Za-z]{19}$|^[0-9A-Za-z]{20}$/.test(this.formData.purchaserTaxNo.replace(/\s*/g, ''))) {
            Notify({ type: 'danger', message: '开票税号格式有误' })
            return false
          }
        } else {
          if (this.formData.purchaserTaxNo && (!/^[a-zA-Z0-9]+$/.test(this.formData.purchaserTaxNo) || this.formData.purchaserTaxNo.length > 20)) {
            Notify({ type: 'danger', message: '税号格式错误仅支持数字/字母，长度小于/等于20位' })
            return false
          }
        }
      }
      return true
    },
    testPurchaserEmail () {
      if (this.settlementInfo.invoiceType !== 3 && this.settlementInfo.invoiceType !== 4 && this.settlementInfo.invoiceType !== 7 && this.settlementInfo.invoiceType !== 8) {
        Notify({ type: 'danger', message: '所开发票不属于电票' })
        return
      }
      if (this.formData.purchaserEmail) {
        if (!isEmail(this.formData.purchaserEmail)) {
          Notify({ type: 'danger', message: '邮箱格式有误' })
          return false
        }
      }
      return true
    },
    testPurchaserBank () {
      if (this.settlementInfo.invoiceType === 4) { // 电子专票
        if (!this.formData.purchaserBankName) {
          Notify({ type: 'danger', message: '请填写开户行、账号' })
          return false
        }
      }
      return true
    },
    testPurchaserAddress () {
      if (this.settlementInfo.invoiceType === 4) { // 电子专票
        if (!this.formData.purchaserAddress) {
          Notify({ type: 'danger', message: '请填写地址、电话' })
          return false
        }
      }
      return true
    }
  }
}
</script>
<style lang="less" scoped src="./index.less"/>
